import { useEffect, useState, useRef } from 'react'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import EventiItem from './components/eventiItem'

function EventiByUser() {
    const navigate = useNavigate()
    const location = useLocation()
    const { idUtente, emailUtente, img } = location.state
    const [userEventi, setUserEventi] = useState([])
    const [profiloArtista, setProfiloArtista] = useState()
    const [profiloFoodTruck, setProfiloFoodTruck] = useState()

    const visualDivElimina = useRef()

    useEffect(() => {
        if (!localStorage.getItem('logged') || localStorage.getItem('email') !== 'maladmin@admin.it') {
            navigate('/', { replace: true })
        }
        try {
            axios.get(`/getEventiById/${idUtente}`).then(res => {
                setUserEventi(res.data)
            })
            axios.post(`/getArtista/${idUtente}`).then(res => {
                const bnm = res.data.filter(item => item.sezione === 'artista')
                const mnb = res.data.filter(item => item.sezione === 'truck')
                if (bnm.length !== 0) { setProfiloArtista(bnm[0]) }
                if (mnb.length !== 0) { setProfiloFoodTruck(mnb[0]) }
            })
        } catch (err) { console.error(err) }
    }, [])

    function approva() {
        axios.post(`/removeUtente/${idUtente}`).then(res => {
            if (res.data.message = 'Success') {
                navigate('/utenti', { replace: true })
            }
        })
    }
    // useEffect(() => { console.log('foodTruck:', profiloFoodTruck) }, [profiloArtista])
    return (<>
        <AuthProvider />
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <div className='container' style={{ marginTop: '7rem', marginBottom: '5em' }}>
            <div style={{ border: '1px solid grey', marginBottom: '2rem', padding: '1rem' }}>
                <p className='m-1'>{emailUtente}</p><br />
                {img &&
                    <p>Foto: <img src={`https://leuro-bucket.s3.amazonaws.com/${img}`} style={{ maxWidth: '100px', maxHeight: '100px', marginLeft: '3em' }} /></p>
                }
                <button style={{ backgroundColor: 'red', color: 'white', border: 'none' }} onClick={() => {
                    visualDivElimina.current.style.display = 'block'
                }}>
                    Elimina utente
                </button>

            </div>
            {profiloArtista &&
                <div style={{ border: '1px solid grey', padding: '5px' }}>
                    🎵<a href='checkArtisti'> Profilo artista esistente</a>
                    <div className='mt-2'>
                        <p>Nome artista: <b>{profiloArtista.nome} {profiloArtista.cognome}</b></p>
                        <p>Genere: <b>{profiloArtista.genere}</b></p>
                        <p>ID: {profiloArtista.id}</p>
                    </div>
                </div>
            }
            {profiloFoodTruck &&
                <div style={{ border: '1px solid grey', padding: '5px', marginTop: '1em' }}>
                    🍔<a href='checkFoodTruck'> Profilo foodTruck esistente</a>
                    <div className='mt-2'>
                        <p>Nome FoodTruck: <b>{profiloFoodTruck.nome} {profiloFoodTruck.cognome}</b></p>
                        <p>Genere: <b>{profiloFoodTruck.genere}</b></p>
                        <p>ID: {profiloFoodTruck.id}</p>
                    </div>
                </div>
            }
            <hr />
            <h4 className='text-center'>Eventi dell'utente</h4>
            <div className="row row-cols-1 row-cols-md-3 g-4">
                {userEventi && userEventi.map((item, index) => (
                    <EventiItem
                        key={item.id}
                        id={item.id}
                        userId={item.userId}
                        accettazione={item.accettazione}
                        città={item.città}
                        comune={item.comune}
                        provincia={item.provincia}
                        dataInizio={item.dataInizio}
                        dataFine={item.dataFine}
                        descrizione={item.descrizione}
                        opzioniBiglietto={item.opzioniBiglietto}
                        oraFine={item.oraFine}
                        oraInizio={item.oraInizio}
                        prezzo={item.prezzo}
                        tipologia={item.tipologia}
                        titolo={item.titolo}
                        img={item.img}
                    />
                ))}
            </div>
            {userEventi.length === 0 && <p><br />Non ci sono eventi inseriti dall'utente</p>}
            <button className='btn btn-secondary' onClick={
                () => { navigate('/utenti', { replace: true }) }}>Indietro</button>

            {/* ------------ BANNER ELIMINA UTENTE --------------- */}
            <div ref={visualDivElimina} style={{
                display: 'none',
                position: 'fixed',
                border: '1px solid grey',
                backgroundColor: 'cornsilk',
                top: '30%',
                left: '0',
                right: '0',
                margin: 'auto',
                width: '70%',
                height: '40%',
                padding: '2rem',
                zIndex: '1',
                borderRadius: '10px'
            }}>
                Eliminare definitivamente l'utente?
                <div className='mt-5'>
                    <button className='float-start btn btn-danger'
                        onClick={() => {
                            visualDivElimina.current.style.display = 'none'
                            approva()
                        }}>Elimina</button>
                    <button className='float-end btn btn-success'
                        onClick={() => { visualDivElimina.current.style.display = 'none' }}>Annulla</button>
                </div>
            </div>
        </div>
    </>)
}
export default EventiByUser